export const collaborationsStateKey = 'COLLABORATIONS' as const;
